import { apiCall } from 'modules/core/services/api'
import { TikTokService } from 'openapi/services/TikTokService'
import type { TikTokCreatorInfoDto } from 'openapi/models/TikTokCreatorInfoDto'
import { useCallback, useEffect, useState } from 'react'
import { extractApiError } from '../utils/extract-api-error'

export type TikTokCreatorInfo = TikTokCreatorInfoDto

/**
 * TikTok's creator_info for the business's connected account. The audience
 * dropdown and interaction toggles in the TikTok post UI are built from it
 * (TikTok's Content Sharing Guidelines: the creator's own options, no
 * defaults, disabled interactions greyed out). Fetched while `enabled`.
 */
export function useTikTokCreatorInfo(enabled: boolean) {
  const [info, setInfo] = useState<TikTokCreatorInfo | null>(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const load = useCallback(async () => {
    setLoading(true)
    setError(null)
    try {
      const result = await apiCall(TikTokService.tikTokControllerGetCreatorInfoV1, null)
      setInfo(result)
    } catch (err) {
      setInfo(null)
      setError(extractApiError(err))
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    if (!enabled) return
    void load()
  }, [enabled, load])

  return { info, loading, error, refetch: load }
}
